<template>
  <v-app class="login-container">
    <v-progress-linear
      :active="loadingBar"
      :indeterminate="loadingBar"
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <img
              src="https://www.opinew.com/_nuxt/img/opinew-feature-page-footer-opinew-logo.162c295.png"
              alt=""
              class="mb-12 logo"
            />
            <v-card class="elevation-12">
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                  ></v-text-field>

                  <v-text-field
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    :type="type"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword"
                    v-model="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text dark-blue-btn"
                  @click.native.prevent="login(email, password)"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { storage } from '@/utils/storage';

export default {
  name: 'Login',
  data() {
    return {
      loadingBar: false,
      type: 'password',
      show1: false,
      password: '',
      email: '',
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },
  mounted: function() {
    console.log('mount', this.$cookies.keys());
  },
  methods: {
    login(email, password) {
      this.loadingBarStart();

      const postData = {
        email,
        password,
      };

      const url = '/api/support/auth';
      this.$http.post(url, postData).then((res) => {
        storage.setItem('OPW_TOKEN', res.data.token);
        this.$cookies.set('logged_in', new Date().getTime());
        this.$router.push({ path: '/' });
        console.log(this.$cookies.keys());
        this.loadingBarEnd();
      });
    },
    logout() {
      const url = '/api/support/logout';
      this.$http.post(url).then(() => {
        this.$cookies.remove('logged_in');
        storage.removeItem('OPW_TOKEN');
      });
    },
    showPassword() {
      this.show1 = !this.show1;
      if (this.type === 'password') {
        this.type = 'text';
      } else {
        this.type = 'password';
      }
    },
    loadingBarStart() {
      this.loadingBar = true;
    },
    loadingBarEnd() {
      this.loadingBar = false;
    },
  },
};
</script>

<style scoped>
.login-container {
  background-color: #131836;
}

.dark-blue-btn {
  background-color: #0d1024 !important;
}

.logo {
  max-width: 250px;
  text-align: center;
  margin: auto;
  display: block;
}
</style>
